import Vue from 'vue';
export class TreeState {
  constructor() {
    this.panelState = {
      // top: 0,
      // left: 0,
      // width: 0,
      // scrollBarWidth: 0,
      scrollWidth: 0
    };
    Vue.observable(this);
    this.update = this.update.bind(this);
  }
  init(el) {
    this.el = el;
    this.update();
    this.bind();
  }
  bind() {
    this.el.addEventListener('scroll', this.update);
    this.ob = new ResizeObserver(entries => {
      entries.forEach(entry => {
        if (entry.target !== this.el) return;
        this.update();
      });
    });
    this.ob.observe(this.el);
  }
  onScroll() {
    this.panelState.scrollWidth = this.el.scrollWidth;
  }
  update() {
    // const { top, left, width } = this.el.getBoundingClientRect();
    // this.panelState.top = top;
    // this.panelState.left = left;
    // this.panelState.width = width;
    // this.panelState.scrollBarWidth = this.el.offsetWidth - this.el.clientWidth;
    this.panelState.scrollWidth = this.el.scrollWidth;
  }
  unBind() {
    this.ob.disconnect();
    this.el.removeEventListener('scroll', this.update);
  }
}
export const TREESTATE = 'ui-core:ds-inner-tree-state';
//# sourceMappingURL=TreeState.js.map
